import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './MerchantAdmin.css';

function ContactSettings() {
    const [contact, setContact] = useState('');
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [message, setMessage] = useState('');

    useEffect(() => {
        fetchContact();
    }, []);

    const fetchContact = async () => {
        const tg = window.Telegram.WebApp;
        try {
            const res = await axios.get('/api/merchant/contact', {
                headers: { 'x-telegram-init-data': tg.initData }
            });
            setContact(res.data.contact || '');
            setLoading(false);
        } catch (err) {
            console.error(err);
            setLoading(false);
        }
    };

    const saveContact = async () => {
        setSaving(true);
        const tg = window.Telegram.WebApp;
        try {
            await axios.post('/api/merchant/contact', { contact }, {
                headers: { 'x-telegram-init-data': tg.initData }
            });
            setMessage('保存成功');
            setTimeout(() => setMessage(''), 2000);
        } catch (err) {
            setMessage('保存失败');
        } finally {
            setSaving(false);
        }
    };

    if (loading) return <div className="loading">加载中...</div>;

    return (
        <div className="merchant-admin-card">
            <h2>联系方式设置</h2>
            <div className="merchant-admin-form">
                <div className="merchant-admin-form-group">
                    <label>联系电话/客服微信等</label>
                    <input
                        type="text"
                        value={contact}
                        onChange={e => setContact(e.target.value)}
                        placeholder="例如：+60 12345678"
                    />
                    <small>该联系方式将显示给顾客，方便联系</small>
                </div>
                <button className="merchant-admin-btn" onClick={saveContact} disabled={saving}>
                    {saving ? '保存中...' : '保存'}
                </button>
                {message && <p className="form-message">{message}</p>}
            </div>
        </div>
    );
}

export default ContactSettings;